$(document).ready(function() {
  $('.complete-set-special__slider').each(function() {
    var $slider = $(this);

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              arrows: false
            }
          }
        ]
      });
    }
  });

  $(document).on('change', '.complete-set-special select', function() {
    var $select = $(this);
    var $option = $select.find('option:selected');
    var price = $option.data('price');
    var image = $option.data('imagen');
    var $card = $select.closest('.ctl-product');

    if (price) {
      $card.find('.ctl-product__current-price').text(price);
    }

    if (image) {
      $card.find('.ctl-product__image img').attr('src', image);
    }
  });

  $(document).on('click', '.complete-set-special .ctl-product__addToCart', function() {
    var $button = $(this);
    var $card = $button.closest('.ctl-product');
    var $select = $card.find('select');
    var variantId = $select.val();

    if (!variantId) return;

    var productData = {
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    };

    $button.text('Adding...').prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: productData,
      dataType: 'json',
      success: function() {
        $button.text('Added!');

        setTimeout(function() {
          $button.text('Add To Cart').prop('disabled', false);
        }, 1000);
      },
      error: function() {
        console.log('Error al agregar el producto al carrito');
        $button.text('Add To Cart').prop('disabled', false);
      }
    });
  });
});